export const styleSheet = theme => {
    const resultTd = {
        cursor: 'pointer',
        verticalAlign: 'middle',
        fontSize: theme.fonts.fontSizes.size03,
        paddingTop: 12,
        paddingBottom: 12,
        lineHeight: '1em',
        paddingRight: theme.margins.margin01,
        ':first-of-type': {
            verticalAlign: 'top',
            width: 44,
            paddingLeft: theme.margins.margin00,
            paddingRight: theme.margins.margin00
        },
        ':last-of-type': {
            paddingRight: 14
        }
    };

    return {
        results: {
            width: '100%'
        },
        result: {
            td: {
                ...resultTd
            },
            ':nth-of-type(even)': {
                td: {
                    backgroundColor: theme.colors.gray10
                }
            }
        },
        resultHighlighted: {
            td: {
                ...resultTd,
                backgroundColor: theme.colors.blue08,
                color: theme.colors.white01,
                div: {
                    color: theme.colors.white01
                },
                em: {
                    color: theme.colors.black01
                },
                p: {
                    color: theme.colors.white01
                },
                '.equityInitials': {
                    color: theme.colors.gray06
                }
            }
        },
        equityInitials: {
            backgroundColor: theme.colors.gray03,
            color: theme.colors.gray06,
            width: 24,
            height: 24,
            borderRadius: 12,
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        companyIcon: {
            width: 24,
            height: 24,
            borderRadius: 12,
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            img: {
                maxHeight: 24
            }
        },
        resultTop: {
            display: 'flex',
            justifyContent: 'space-between'
        },
        transcript: {
            ...theme.content.annotated,
            marginTop: 6,
            color: theme.colors.gray08,
            fontSize: theme.fonts.fontSizes.size01,
            lineHeight: '1.3em'
        },
        loaderCell: {
            padding: `${theme.margins.margin03} 0`,
            div: {
                margin: 'auto'
            }
        },
        loadingMore: {
            padding: '12px 0',
            div: {
                margin: 'auto'
            }
        },
        loadButtonRow: {
            td: {
                padding: 10
            }
        },
        loadMoreButton: {
            borderRadius: 6,
            justifyContent: 'center',
            p: {
                color: theme.colors.gray04
            },
            ':hover': {
                backgroundColor: theme.colors.white02,
                p: {
                    color: theme.colors.black01
                }
            }
        },
        loadMoreButtonHighlighted: {
            borderRadius: 6,
            justifyContent: 'center',
            boxShadow: `0 0 0 1px ${theme.colors.blue08}`,
            p: {
                color: theme.colors.blue08
            },
            ':hover': {
                backgroundColor: theme.colors.white02,
                p: {
                    color: theme.colors.black01
                }
            }
        },
        eventDateTime: {
            color: theme.colors.gray04
        },
        eventTime: {
            color: theme.colors.gray06
        },
        subTitle: {
            color: theme.colors.gray06
        }
    };
};
